export default __webpack_public_path__ + "static/media/equipar_item_01.a7a9caec.mp3";